export const properties = {
    host: "https://api.score.fortytwodegrees.org",
    google: {
        clientId: "271547686743-bfssigv25gqauasdpvvsjb8n61v9kv0k.apps.googleusercontent.com"
    }
}